var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 33,
    viewBox: "0 0 35 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9664 20.5926H27.0506C24.5112 20.5911 22.453 18.5344 22.4514 15.9951C22.4514 13.4557 24.5112 11.399 27.0506 11.3975H33.9664",
    stroke: "url(#paint0_linear_261_153)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.833 15.89H27.3006",
    stroke: "url(#paint1_linear_261_153)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2355 1.125H25.0014C29.9524 1.125 33.9661 5.13875 33.9661 10.0898V22.3505C33.9661 27.3015 29.9524 31.3153 25.0014 31.3153H10.2355C5.2845 31.3153 1.27075 27.3015 1.27075 22.3505V10.0898C1.27075 5.13875 5.2845 1.125 10.2355 1.125Z",
    stroke: "url(#paint2_linear_261_153)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01904 8.87758H18.2423",
    stroke: "url(#paint3_linear_261_153)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_261_153",
    x1: 36.4885,
    y1: 4.40743,
    x2: 41.2218,
    y2: 13.2188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26468B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26468B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_261_153",
    x1: 28.6863,
    y1: 13.928,
    x2: 29.5766,
    y2: 15.2515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26468B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26468B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_261_153",
    x1: 41.1272,
    y1: -21.8252,
    x2: 57.8361,
    y2: 5.07406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26468B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26468B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_261_153",
    x1: 20.2624,
    y1: 6.91557,
    x2: 20.4779,
    y2: 8.81355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26468B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26468B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.755cfddc3f2358d746f2e42765473bf9.svg";
export { ForwardRef as ReactComponent };